import {Colors} from "../consts/Colors.js"
import {tags} from "../consts/Tags.js"

export default class RoundedButton2 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, w, texte) {
        // Create container
        super(scene, x, y, []);
        scene.add.existing(this);

        // Add variable
        this.scene = scene;
        this.strokeWidth = 3;
        this.durationAnim = 400;

        this.text = texte;
        this.locked = false;

        // Add objects
        this.rectButton = this.scene.add.rexRoundRectangle(0, 0, w, 50, 25, Colors.Elmt.DarkBlue);
        this.add(this.rectButton);

        this.textButton = this.scene.add.rexTagText(0, 0, this.text, {
            fontSize: '24px',
            fontFamily: 'MassiliaMedium',
            color: Colors.Text.White,
            backgroundColor: 'transparent',
            align: "center",
            tags: tags
        });
        this.textButton.setOrigin(0.5)
        this.add(this.textButton);

        // Add interaction
        this.setSize(this.rectButton.width, this.rectButton.height);
        this.setInteractive({useHandCursor: true});

        this.on('pointerover', function (){
            if(!this.locked)
                this.pointerOver();
        });

        this.on('pointerout', function (){
            if(!this.locked)
                this.pointerOut();
        });

    }

    setClickFunction(func){
        this.on('pointerup', () => {
            func();
        })
    }

    pointerOver(){
        this.rectButton.setFillStyle(Colors.Elmt.Orange, 1)
    }

    pointerOut(){
        this.rectButton.setFillStyle(Colors.Elmt.DarkBlue, 1);
    }
    setText(text){
        this.textButton.setText(text);
    }

    setLocked(){
        this.locked = true;
        this.rectButton.setFillStyle(Colors.Elmt.LightGrey, 1);
        this.disableInteractive();
    }

    setUnlocked(){
        this.locked = false;
        this.rectButton.setFillStyle(Colors.Elmt.DarkBlue, 1);
        this.setSize(this.rectButton.width, this.rectButton.height);
        this.setInteractive({useHandCursor: true});
    }

}